import { render, staticRenderFns } from "./maintainfrom.vue?vue&type=template&id=632070c2&scoped=true&"
import script from "./maintainfrom.vue?vue&type=script&lang=js&"
export * from "./maintainfrom.vue?vue&type=script&lang=js&"
import style0 from "./maintainfrom.vue?vue&type=style&index=0&id=632070c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632070c2",
  null
  
)

export default component.exports